<template>
  <div class="container container_40 trade-orders">
    <buy-order :assets="assets" class="trade-orders__item"/>
    <sell-order :assets="assets" class="trade-orders__item"/>
  </div>
</template>

<script>
  import BuyOrder from './TradeOrders.BuyOrder'
  import SellOrder from './TradeOrders.SellOrder'

  export default {
    name: 'trade-orders',
    components: { BuyOrder, SellOrder },
    props: {
      assets: { type: Object, require: true }
    },
    data () {
      return {

      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~scss/mixins";
  @import "~scss/variables";

  .trade-orders {
    display: flex;
    justify-content: space-between;

    @include respond-to(medium) {
      flex-direction: column;
    }

    &__item {
      flex: 1 1 50%;

      &:last-child {
        margin-left: 24px;

        @include respond-to(medium) {
          margin-top: 16px;
          margin-left: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/trade/index/components/tradeOrders/Trade.TradeOrders.vue